export default __webpack_public_path__ + "static/media/pic6.0a8121d3.jpg";